import { render, staticRenderFns } from "./VisualizarSerieDialog.vue?vue&type=template&id=0ba67bbe"
import script from "./VisualizarSerieDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarSerieDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports